import RdvCard from "../../../Component/RdvCard/RdvCard";
import "./mesRdv.css";
import { useState, useEffect } from "react";
import { BASE_URL } from "../../../api";

const getApiBase = () => {
  const raw = (typeof import.meta !== "undefined" && import.meta.env?.VITE_API_URL) || BASE_URL || process.env.REACT_APP_API_URL || "";
  return (raw ? raw.replace(/\/+$/, "").replace(/\/api$/i, "") : "") || "http://localhost:5000";
};

const MesRdv = () => {
  const [inputTitleActivity, setInputTitleActivity] = useState("");
  const [inputDescriptionActivity, setInputDescriptionActivity] = useState("");
  const [inputDurationActivity, setInputDurationActivity] = useState("");
  const [activites, setActivites] = useState([]);
  const [filteredActivites, setFilteredActivites] = useState([]);

  const API_BASE = getApiBase();
  const token = localStorage.getItem("token");
  const authHeader = token ? { Authorization: `Bearer ${token}` } : {};

  useEffect(() => {
    const userId = localStorage.getItem("userId");
    if (!userId) {
      console.error("Aucun userId trouvé");
      return;
    }
    fetch(`${API_BASE}/api/slotsCalendar/user/${userId}`, { headers: authHeader })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Erreur lors de la récupération des activités");
        }
        return response.json();
      })
      .then((data) => {
        setActivites(data);
        setFilteredActivites(data);
      })
      .catch((error) => {
        console.error("Erreur fetch :", error);
      });
  }, []);

  // 🔥 Filtrage dynamique selon input utilisateur
  useEffect(() => {
    const results = activites.filter((activite) => {
      const matchTitle = inputTitleActivity
        ? activite.title
            .toLowerCase()
            .includes(inputTitleActivity.toLowerCase())
        : true;
      const matchDescription = inputDescriptionActivity
        ? activite.description
            .toLowerCase()
            .includes(inputDescriptionActivity.toLowerCase())
        : true;
      return matchTitle && matchDescription;
    });
    setFilteredActivites(results);
  }, [inputTitleActivity, inputDescriptionActivity, activites]);

  // 🔥 Suppression d'une activité avec sécurisation (userId envoyé)
  const handleDelete = (id) => {
    const userId = localStorage.getItem("userId");
    if (!userId) {
      console.error("Aucun userId trouvé");
      return;
    }
    fetch(`${API_BASE}/api/slotsCalendar/${id}?userId=${userId}`, {
      method: "DELETE",
      headers: { "Content-Type": "application/json", ...authHeader },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Erreur lors de la suppression de l'activité");
        }
        // Mise à jour local
        const updatedActivites = activites.filter(
          (activite) => activite._id !== id
        );
        setActivites(updatedActivites);
        setFilteredActivites(updatedActivites);
      })
      .catch((error) =>
        console.error("Erreur lors de la suppression :", error)
      );
  };

  // 🔥 Affichage de toutes les activités
  const activiteElements = (
    inputTitleActivity || inputDescriptionActivity
      ? filteredActivites
      : activites
  ).map((activiteInfo) => (
    <div key={activiteInfo._id} className="activityCard">
      <RdvCard
        titre={activiteInfo.title}
        description={activiteInfo.description}
      />
      <div>
        <button
          className="delete"
          onClick={() => handleDelete(activiteInfo._id)}
        >
          Supprimer
        </button>
      </div>
    </div>
  ));

  return (
    <div>
      <section className="rdvSection">
        <h1 className="mainTitle">Gestion des activités</h1>
        <div>
          <input
            placeholder="Titre de l'activité"
            value={inputTitleActivity}
            onChange={(e) => setInputTitleActivity(e.target.value)}
            className="titleActivityInput"
          />
          <input
            placeholder="Description (optionnel)"
            value={inputDescriptionActivity}
            onChange={(e) => setInputDescriptionActivity(e.target.value)}
            className="descriptionActivityInput"
          />
        </div>
        <div>{activiteElements}</div>
      </section>
    </div>
  );
};

export default MesRdv;